import React, { useEffect, useState } from 'react';
import PageLayout from '../components/layout/PageLayout';
import EventCard from '../components/features/EventCard';
import RegistrationDialog from '../components/features/RegistrationDialog';
import { Skeleton } from '../components/ui/Skeleton';
import { api } from '../services/api';

const NAV_LINKS = [
  { label: 'Sobre Nós', to: '/sobre' },
  { label: 'Pregações', to: '/pregações' },
  { label: 'Células', to: '/celulas' },
  { label: 'Eventos', to: '/evento' },
  { label: 'Galeria', to: '/galeria' },
  { label: 'Contato', to: '/contato' },
];

const FOOTER_COLUMNS = [
  {
    title: 'Navegação',
    links: [
      ['Em que Cremos', '/sobre'],
      ['História', '/sobre'],
      ['Eventos', '/evento'],
      ['Células', '/celulas'],
      ['Galeria', '/galeria'],
    ],
  },

  {
    title: 'Institucional',
    links: [
      ['Política de Privacidade', '/privacidade'],
      ['Relatórios', '/relatorios'],
      ['Doações', '/contato'],
      ['Área Administrativa', '/admin'],
    ],
  },
];

export default function Agenda() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null); // { event, onDone }

  useEffect(() => {
    api.getEvents().then((e) => {
      const sorted = [...e].sort((a, b) => new Date(a.date) - new Date(b.date));
      setEvents(sorted);
      setLoading(false);
    });
  }, []);

  function handleRegister(event, onDone) {
    setActive({ event, onDone });
  }

  return (
    <PageLayout navLinks={NAV_LINKS} footerColumns={FOOTER_COLUMNS}>
      <div className="border-b border-slate-200/60 bg-canvas py-3">
        <div className="app-container">
          <div className="py-2">
            <h1 className="font-heading text-2xl font-extrabold tracking-tight text-ink md:text-3xl">
              Eventos
            </h1>

            <p className="mt-0.5 text-sm text-ink-soft">Garanta sua vaga nos próximos encontros</p>
          </div>
        </div>
      </div>

      <div className="app-container grid gap-4 py-4 md:grid-cols-2 xl:grid-cols-3">
        {loading
          ? Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-64 w-full rounded-2xl" />
            ))
          : events.map((ev, i) => (
              <EventCard key={ev.id} event={ev} index={i} onRegister={handleRegister} />
            ))}
      </div>

      <RegistrationDialog
        event={active?.event}
        onClose={() => setActive(null)}
        onSuccess={() => active?.onDone?.()}
      />
    </PageLayout>
  );
}
